import React from "react";
import { Link } from "react-router-dom";
import translations from "../utils/data";

const BlogList = () => {
  return (
    <main className="mx-auto py-10 px-4">
      <div className="text-center mb-12 bg-gradient-to-br from-[#9f7a2f22] to-[#9f7a2f11] py-12 px-5 rounded-2xl">
        <h1 className="text-4xl md:text-5xl text-[#1a1a1a] mb-4">
          Sacred Knowledge Blog
        </h1>
        <p className="text-[1.1em] text-[#666] max-w-[600px] mx-auto leading-relaxed">
          Explore ancient wisdom, spiritual practices, and sacred traditions through our collection of thoughtfully curated articles.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 px-5">
        {translations.blogs.map((b) => (
          <article
            key={b.id}
            className="relative overflow-hidden cursor-pointer h-full flex flex-col border border-[#eee] rounded-2xl p-6 bg-white transition-all duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-xl"
          >
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#9f7a2f] to-[#d4af37]" />

            <div className="flex-1">
              <h2 className="mt-4 mb-3 text-[#1a1a1a] text-2xl leading-snug">
                {b.title}
              </h2>

              <div className="flex items-center gap-3 my-3 text-[#666] text-[0.9em]">
                <span className="px-3 py-1 bg-[#9f7a2f11] rounded-[12px] text-[#9f7a2f]">
                  {b.date}
                </span>
                <span>•</span>
                <span>{b.readTime}</span>
              </div>

              <p className="mb-6 leading-relaxed text-[#444] text-base">
                {b.excerpt}
              </p>
            </div>

            <Link
              to={`/blog/${b.slug}`}
              className="text-[#9f7a2f] no-underline font-semibold inline-flex items-center gap-2 text-[1.1em] mt-auto py-2"
            >
              Read Article
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </article>
        ))}
      </div>
    </main>
  );
};

export default BlogList;


// import React from "react";
// import { Link } from "react-router-dom";
// import translations from "../utils/data";

// const BlogList = () => {
//   return (
//     <main style={{ margin: "0 auto", padding: "40px 16px" }}>
//       <div style={{ 
//         textAlign: "center", 
//         marginBottom: 48,
//         background: "linear-gradient(45deg, #9f7a2f22, #9f7a2f11)",
//         padding: "48px 20px",
//         borderRadius: "16px"
//       }}>
//         <h1 style={{ 
//           fontSize: "2.5em", 
//           color: "#1a1a1a",
//           marginBottom: "16px"
//         }}>Sacred Knowledge Blog</h1>
//         <p style={{
//           fontSize: "1.1em",
//           color: "#666",
//           maxWidth: 600,
//           margin: "0 auto",
//           lineHeight: 1.6
//         }}>Explore ancient wisdom, spiritual practices, and sacred traditions through our collection of thoughtfully curated articles.</p>
//       </div>

//       <div style={{ 
//         display: "grid", 
//         gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", 
//         gap: 32,
//         padding: "0 20px"
//       }}>
//         {translations.blogs.map((b) => (
//           <article
//             key={b.id}
//             style={{ 
//               border: "1px solid #eee",
//               borderRadius: 16,
//               padding: 24,
//               transition: "all 0.3s ease",
//               background: "white",
//               boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
//               position: "relative",
//               overflow: "hidden",
//               cursor: "pointer",
//               height: "100%",
//               display: "flex",
//               flexDirection: "column"
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = "translateY(-4px)";
//               e.currentTarget.style.boxShadow = "0 12px 24px rgba(0,0,0,0.1)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = "translateY(0)";
//               e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)";
//             }}
//           >
//             <div style={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "4px",
//               background: "linear-gradient(90deg, #9f7a2f, #d4af37)"
//             }} />
            
//             <div style={{ flex: 1 }}>
//               <h2 style={{ 
//                 margin: "16px 0 12px", 
//                 color: "#1a1a1a",
//                 fontSize: "1.5em",
//                 lineHeight: 1.3
//               }}>{b.title}</h2>
              
//               <div style={{ 
//                 display: "flex", 
//                 alignItems: "center", 
//                 gap: "12px",
//                 margin: "12px 0",
//                 color: "#666",
//                 fontSize: "0.9em"
//               }}>
//                 <span style={{
//                   padding: "4px 12px",
//                   background: "#9f7a2f11",
//                   borderRadius: "12px",
//                   color: "#9f7a2f"
//                 }}>{b.date}</span>
//                 <span>•</span>
//                 <span>{b.readTime}</span>
//               </div>

//               <p style={{ 
//                 margin: "0 0 24px", 
//                 lineHeight: 1.6,
//                 color: "#444",
//                 fontSize: "1em"
//               }}>{b.excerpt}</p>
//             </div>

//             <Link 
//               to={`/blog/${b.slug}`} 
//               style={{ 
//                 color: "#9f7a2f",
//                 textDecoration: "none",
//                 fontWeight: 600,
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 fontSize: "1.1em",
//                 marginTop: "auto",
//                 padding: "8px 0"
//               }}
//             >
//               Read Article 
//               <svg 
//                 width="20" 
//                 height="20" 
//                 viewBox="0 0 24 24" 
//                 fill="none" 
//                 stroke="currentColor" 
//                 strokeWidth="2" 
//                 strokeLinecap="round" 
//                 strokeLinejoin="round"
//               >
//                 <path d="M5 12h14M12 5l7 7-7 7"/>
//               </svg>
//             </Link>
//           </article>
//         ))}
//       </div>
//     </main>
//   );
// };

// export default BlogList;
